import { clubQueryKeys } from "@gymflow/api";
import { CancellationReasonDTO } from "@gymflow/types";
import { InfiniteData, infiniteQueryOptions } from "@tanstack/react-query";
import {
  FormSelectInput,
  SettingsIcon,
} from "apps/portal/src/components/atoms";
import { ModalContext } from "apps/portal/src/providers";
import useGymflowModels from "apps/portal/src/store";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { ApiResolverContext } from "../../../../../../providers/ApiResolverProvider/ApiResolverContext";
import { CancelMembershipFormValues } from "../types";
import { CancellationReasonsModal } from "./CancellationReasonsModal";

export const FormCancellationReasonSelect = () => {
  const { t } = useTranslation();
  const { clubId } = useContext(ApiResolverContext);
  const { api } = useGymflowModels();
  const { setModal, hide } = useContext(ModalContext);

  return (
    <FormSelectInput<CancelMembershipFormValues, number>
      name="cancellationReason"
      label={t(
        "components.cancelMembershipSidebar.formCancellationReasonSelect.label",
      )}
      isMulti={false}
      listButton={{
        title: t(
          "components.cancelMembershipSidebar.formCancellationReasonSelect.listButtonTitle",
        ),
        icon: (
          <SettingsIcon className="size-5" pathClassName="stroke-gray-500" />
        ),
        onClick: () =>
          setModal(<CancellationReasonsModal onHide={() => hide()} />),
      }}
      dataFetchingQuery={() =>
        infiniteQueryOptions({
          queryKey: clubQueryKeys.getCancellationReasonList(clubId),
          queryFn: async () =>
            (await api.clubApi.getCancellationReasonList(clubId)).data,
          select: (data) => {
            const { pageParams, pages } = data as InfiniteData<
              CancellationReasonDTO[]
            >;

            const transformedPages = pages.map((page) =>
              page.map(({ id, name }) => ({
                id,
                label: name,
                value: id,
              })),
            );

            return {
              pageParams,
              pages: transformedPages,
            };
          },
          initialPageParam: undefined,
          getNextPageParam: () => undefined,
        })
      }
    />
  );
};
